/**
 * The pinned nav row (unit convention §1). Context-free (UX spec §6a) — see the
 * `no-restricted-imports` override for `rail/live/**` in .eslintrc.js.
 */
import React from 'react';

import {useMoveNavModel} from './model';
import MoveNavView from './View';

export default React.memo(function MoveNav() {
  return <MoveNavView {...useMoveNavModel()} />;
});
